import { render, staticRenderFns } from "./WorldNew.vue?vue&type=template&id=537c264c&scoped=true"
import script from "./WorldNew.vue?vue&type=script&lang=js"
export * from "./WorldNew.vue?vue&type=script&lang=js"
import style0 from "./WorldNew.vue?vue&type=style&index=0&id=537c264c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537c264c",
  null
  
)

export default component.exports